import { render } from "./2faView.vue?vue&type=template&id=2cef8668"
import script from "./2faView.vue?vue&type=script&lang=js"
export * from "./2faView.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__